<div class="w-full h-full">
    <div #leftPanel class="h-full border-r-1 border-slate-300">
        <ng-content select="#left-column"></ng-content>
    </div>
    <div>
        <ng-content select="#right-column"></ng-content>
    </div>
</div>
